import { injectEmspBoChargingSessionApi } from '@delmonicos/shared-sdk/libs/cpms/src/clients/redux/emsp-bo-charging-session.service';

import { baseApi } from '@service/base-api.service';

export const emspBoChargingSessionApi = injectEmspBoChargingSessionApi(baseApi);

export const {
  useEmspBoGetChargingSessionQuery,
  useEmspBoGetChargingSessionsQuery,
} = emspBoChargingSessionApi;
